import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { Button, Icon, message, Modal } from '@whalecloud/fdx';

import { StepFooter } from '@/components';
import CustomerOrderAttributes from './AttributeInfo/CustomerOfferAttributes';

import { StepMap } from './config';
import { ActTypeObj } from '@/utils';
import { SUBS_EVENT_ID } from '@/utils/portalDscm';
import styles from './index.module.less';

const SubsOfferInfo = props => {
  const {
    modelKey, isTransferShift, stepFooterDetail = {}, dispatchType, renderFun = {},
    subsEventId, custId, acctId, addressId, serviceType,
    loading, dispatch, saveMainProdId, subsDetail,
  } = props;

  const [step, setStep] = useState(0);
  const [currentOffer, setCurOffer] = useState({});
  const [currentDpp, setCurrentDpp] = useState({});
  const [currentNumber, setCurNumber] = useState({});
  const [custOrderAttrList, setCustOrderAttrList] = useState([]);
  const attrRef = useRef();
  const custAttrRef = useRef();

  const handleOfferChange = (offer = {}) => setCurOffer(offer); // 套餐选择
  const handleDppChange = (dpp = {}) => setCurrentDpp(dpp);

  const handleNumberChange = async number => {
    const payload = {
      mainOfferInfo: {
        number,
      },
    };
    await dispatch({
      type: `${modelKey}/save`,
      payload: {
        offerInfo: payload,
      },
    });
    setCurNumber(number); // 号码选择
  };

  const handleBack = () => setStep(step - 1);

  const handleNext = async () => {
    const custOrderList = await custAttrRef.current.getAttributeInfo(); // 客户订单属性数据
    setCustOrderAttrList(custOrderList);
    let subsPlanDetailDto = {};
    if (!renderFun.renderOldOffer) {
      // 获取可选scheme过滤条件
      const refAttrDtoList = await dispatch({
        type: 'selectPlan/qrySalesRuleRefAttr',
        payload: {
          subsId: get(subsDetail, 'subsId'),
          acctId,
          addressId,
          subsEventId,
        },
      });
      refAttrDtoList.push({
        attrCode: 'SUBS_PLAN_CODE',
        attrValue: currentOffer.offerCode,
      }, {
        attrCode: 'DPP_OFFER_CODE',
        attrValue: currentDpp.offerCode,
      });
      // 查询所选套餐详情
      subsPlanDetailDto = await dispatch({
        type: 'selectPlan/qrySubsPlanDetailBsnl',
        payload: {
          subsPlanId: currentOffer.offerId,
          addressId,
          refAttrDtoList,
        },
        modelKey,
      });
    }

    if (modelKey === 'virtualConvertToFixedLine') { // 如果是虚转固的话，这时候要拿到主产品id供下一步查询可用号码使用
      const mainProcutId = get(subsPlanDetailDto, 'offerDetail.indepProdSpecDto.indepProdSpecId');
      if (typeof saveMainProdId === 'function') {
        saveMainProdId(mainProcutId);
      }
    }

    setStep(step + 1);
  };

  const handleContinue = async () => {
    // 在DSCM也需要像CRM那样去验证套餐的最小合约期，降套餐需要缴纳罚金。
    if (modelKey === 'modifyPlan') {
      const terminationCheckRes = await dispatch({
        type: 'business/terminationCheckBsnl',
        payload: {
          subsId: subsDetail.subsId,
          subsEventId: SUBS_EVENT_ID.modifyPlan,
          newSubsPlanId: currentOffer.offerId,
          newDppOfferId: currentDpp.offerId,
        },
      });
      if (terminationCheckRes.data && terminationCheckRes.data.agreementFlag === 'Y') {
        Modal.warning({
          content: terminationCheckRes?.data?.descMsg || 'Subscriber agreement period verification',
        });
      }
    }

    if (isEmpty(attrRef.current)) {
      return;
    }
    const { getAttrObj } = attrRef.current;
    const { subsAttrs = {}, comboUnitList, offerGroupInfo, sharedGoodsAttrDtoList = [] } = await getAttrObj();
    // 2839290 新增子成员校验，子成员全选，未全选不能提交
    if (!isEmpty(comboUnitList)) {
      const comboUnitListFlag = comboUnitList.map(plan => {
        const { comboUnitOfferDtoList = [], planList = [] } = plan;
        const necessaryComboUnitOfferDtoList = comboUnitOfferDtoList.filter(offerItem => offerItem.necessary === 'Y'); // 过滤必须的子套餐
        // 新增校验combo新开应该全选子成员
        return necessaryComboUnitOfferDtoList.filter(offerItem => !planList.some(item => item?.offerDetail?.subsPlanId === offerItem.subsPlanId)
        );
      });
      if (comboUnitListFlag[0].length > 0) {
        const subsPlanNameList = [];
        comboUnitListFlag.forEach(item => item.forEach(plan => subsPlanNameList.push(plan.subsPlanName)));
        message.error(`${subsPlanNameList.join(',')} is required.`);
        return;
      }
    }

    const offerInstList = get(offerGroupInfo, 'offerInstList') || [];
    if (isEmpty(offerInstList)) {
      offerGroupInfo.offerInstList = offerInstList;
    }
    if (modelKey === 'newConnection') {
      offerInstList.push({
        offerId: currentDpp.offerId,
        offerName: currentDpp.offerName,
        actType: ActTypeObj.ADD,
      });
    } else {
      offerInstList.push({
        offerId: currentDpp.offerId,
        operationType: ActTypeObj.ADD,
      });
    }

    const payload = {
      mainOfferInfo: {
        offerDetail: { ...currentOffer, offerGroupInfo, dppPrice: currentDpp.mrc },
        number: currentNumber,
      },
      comboUnitList,
      custOrderAttrList,
      sharedGoodsAttrDtoList,
      subsAttrList: subsAttrs.subsAttrList,
      isdnAttrObj: subsAttrs.isdnAttrObj,
    };
    await dispatch({
      type: `${modelKey}/save`,
      payload: {
        offerInfo: payload,
      },
    });
    stepFooterDetail.onContinue(payload);
  };

  const renderStepContent = () => {
    const Page = StepMap[step].component;
    const queryOfferParams = { // 套餐查询参数
      addressId,
      prodId: get(serviceType, 'subServiceType.subServiceType'),
      custId,
      acctId,
      subsEventId,
    };
    const offerProps = {
      subsId: get(subsDetail, 'subsId'),
      modelKey,
      dispatchType,
      queryOfferParams,
      currentOffer,
      mainOfferCurrentDpp: currentDpp,
      onOfferChange: handleOfferChange,
      onDppChange: handleDppChange,
    };
    const attributeProps = {
      ref: attrRef,
      modelKey,
      currentNumber,
      addressId,
      queryNumberParams: { // 号码查询参数
        subsServiceType: get(serviceType, 'subServiceType.subServiceType'),
      },
      queryExchangeOfferParams: {
        custId,
        acctId,
        subsPlanId: currentOffer.offerId,
      },
      onNumberChange: handleNumberChange,
    };
    return Page ? <Page {...offerProps} {...attributeProps} serviceType={serviceType} renderFun={renderFun} /> : null;
  };
  return (
    <div className={`threeColumnWrap ${styles.subsOfferInfo}`}>
      <div className={styles.offerInfo}>
        {
          step === 0 && (
            <div className={styles.custAttrCom}>
              <CustomerOrderAttributes
                custId={custId}
                ref={custAttrRef}
                modelKey={modelKey}
                isTransferShift={isTransferShift}
                custOrderAttrList={custOrderAttrList}
              />
            </div>
          )
        }
        {renderStepContent()}
        <div className={styles.offerStepBtn}>
          {
            step === 1 && (
              <Button onClick={handleBack}>
                <Icon type="left" />
                {i18n('COMMON_BACK')}
              </Button>
            )
          }
          {
            step === 0 && (
              <Button type="primary" loading={loading} onClick={handleNext}>
                {i18n('COMMON_NEXT')}
                <Icon type="right" />
              </Button>
            )
          }
        </div>
      </div>

      <StepFooter
        className={styles.subBtns}
        {...stepFooterDetail}
        onContinue={handleContinue}
        needContinue={step === 1}
      />
    </div>
  );
};

export default connect((state, { modelKey }) => ({
  loading: state.loading.effects['selectPlan/qrySubsPlanDetailBsnl'],
  offerInfo: state[modelKey].offerInfo,
  subsDetail: state[modelKey].subsDetail || {},
}))(SubsOfferInfo);
